import { Checkbox } from '@rsos/base-components';
import { isPublicSonarLayer } from '@rsos/components/capstone/common/Map/selectMarkerIcon';
import { RegularCheckboxWrapper } from './LayerCheckbox.styles';
import { Layer } from './LayerCheckbox.types';

interface NormalizedLayerCheckboxProps {
  layer: Layer;
  layerID: number | string;
  handleCheckboxOnChange: () => void;
}

const NormalizedLayerCheckbox: React.FC<NormalizedLayerCheckboxProps> = ({
  layer,
  layerID,
  handleCheckboxOnChange,
}) => {
  // For spatial layers
  return (
    <RegularCheckboxWrapper>
      <Checkbox
        key={String(layerID)}
        label={layer.title || layer.category?.name || ''}
        isChecked={layer.isChecked}
        description={isPublicSonarLayer(layer.key) ? layer.source : layer.name}
        onChange={handleCheckboxOnChange}
      />
    </RegularCheckboxWrapper>
  );
};

export default NormalizedLayerCheckbox;
